import axios from "@/utils/server.js"
//添加服务器
export const addServerSer = (data) => axios.post("/setup/ServiceProvider", null, { params: data })
    //获取服务器列表
export const getServerListSer = (data) => axios.get("/setup/ServiceProvider", { params: data })
    //修改服务器
export const editServerSer = (data) => axios.put("/setup/ServiceProvider", null, { params: data })
    //删除服务器
export const deleteServerSer = (data) => axios.delete("/setup/ServiceProvider", { params: data })